export default 'WebCryptoAPI';